"use client";
import { jsxs as d, jsx as a, Fragment as Ie } from "react/jsx-runtime";
import { mergeProps as Ve } from "@base-ui/react/merge-props";
import { useRender as Fe } from "@base-ui/react/use-render";
import { c as o, G as Ge, C as qe, f as pe, a as ee, b as Be } from "./card-BC9t8iAS.js";
import { h as mn, j as bn, i as hn, e as vn, d as xn, g as yn } from "./card-BC9t8iAS.js";
import { S as kn, T as Nn } from "./sql-results-table-CkP9HiU4.js";
import * as D from "react";
import { useState as oe, useEffect as ie, useRef as Ae, useCallback as J, useMemo as te } from "react";
import { Button as Ee } from "@base-ui/react/button";
import { Loader2 as Oe, ExternalLinkIcon as Ue, PlusIcon as He, CheckIcon as X, ChevronRightIcon as Je, Check as ae, ChevronDown as Xe, XIcon as De, ChevronDownIcon as W, ChevronUpIcon as Pe, Loader2Icon as We, Copy as Ye, Info as Ke, ListTree as Qe, Bug as Ze, AlertTriangle as et, AlertCircle as tt } from "lucide-react";
import { Input as at } from "@base-ui/react/input";
import { ScrollArea as B } from "@base-ui/react/scroll-area";
import { S as Sn, T as Cn, b as Tn, f as _n, c as In, d as An, a as Dn, e as Pn } from "./skeleton-BhG066C7.js";
import { Menu as x } from "@base-ui/react/menu";
import { Dialog as h } from "@base-ui/react/dialog";
import { AlertDialog as T } from "@base-ui/react/alert-dialog";
import { Select as y } from "@base-ui/react/select";
import { Tooltip as P } from "@base-ui/react/tooltip";
import { Checkbox as ge } from "@base-ui/react/checkbox";
import { Radio as fe } from "@base-ui/react/radio";
import { RadioGroup as rt } from "@base-ui/react/radio-group";
import { Switch as me } from "@base-ui/react/switch";
import { Tabs as Y } from "@base-ui/react/tabs";
import { Progress as se } from "@base-ui/react/progress";
import { Separator as nt } from "@base-ui/react/separator";
import { Accordion as O } from "@base-ui/react/accordion";
import { Collapsible as de } from "@base-ui/react/collapsible";
import { NavigationMenu as k } from "@base-ui/react/navigation-menu";
import { Popover as R } from "@base-ui/react/popover";
import { Avatar as le } from "@base-ui/react/avatar";
function Re(e) {
  var t, r, n = "";
  if (typeof e == "string" || typeof e == "number") n += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var i = e.length;
    for (t = 0; t < i; t++) e[t] && (r = Re(e[t])) && (n && (n += " "), n += r);
  } else for (r in e) e[r] && (n && (n += " "), n += r);
  return n;
}
function ot() {
  for (var e, t, r = 0, n = "", i = arguments.length; r < i; r++) (e = arguments[r]) && (t = Re(e)) && (n && (n += " "), n += t);
  return n;
}
const be = (e) => typeof e == "boolean" ? `${e}` : e === 0 ? "0" : e, he = ot, U = (e, t) => (r) => {
  var n;
  if ((t == null ? void 0 : t.variants) == null) return he(e, r == null ? void 0 : r.class, r == null ? void 0 : r.className);
  const { variants: i, defaultVariants: s } = t, c = Object.keys(i).map((b) => {
    const w = r == null ? void 0 : r[b], N = s == null ? void 0 : s[b];
    if (w === null) return null;
    const v = be(w) || be(N);
    return i[b][v];
  }), u = r && Object.entries(r).reduce((b, w) => {
    let [N, v] = w;
    return v === void 0 || (b[N] = v), b;
  }, {}), m = t == null || (n = t.compoundVariants) === null || n === void 0 ? void 0 : n.reduce((b, w) => {
    let { class: N, className: v, ...$ } = w;
    return Object.entries($).every((_) => {
      let [z, I] = _;
      return Array.isArray(I) ? I.includes({
        ...s,
        ...u
      }[z]) : {
        ...s,
        ...u
      }[z] === I;
    }) ? [
      ...b,
      N,
      v
    ] : b;
  }, []);
  return he(e, c, m, r == null ? void 0 : r.class, r == null ? void 0 : r.className);
}, it = U(
  "inline-flex w-fit shrink-0 items-center justify-center gap-1.5 overflow-hidden rounded-none border px-2 py-0.5 text-[0.625rem] font-semibold uppercase tracking-widest whitespace-nowrap transition-colors focus-visible:border-ring focus-visible:ring-2 focus-visible:ring-ring/30 aria-invalid:border-destructive [&>svg]:pointer-events-none [&>svg]:size-3",
  {
    variants: {
      variant: {
        default: "border-transparent bg-primary text-primary-foreground [a&]:hover:bg-primary/80",
        secondary: "border-transparent bg-secondary text-secondary-foreground [a&]:hover:bg-secondary/80",
        destructive: "border-destructive/20 bg-destructive/10 text-destructive [a&]:hover:bg-destructive/20",
        outline: "border-border text-foreground [a&]:hover:bg-muted [a&]:hover:text-foreground"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
);
function za({
  className: e,
  variant: t = "default",
  render: r,
  ...n
}) {
  return Fe({
    defaultTagName: "span",
    props: Ve(
      { className: o(it({ variant: t }), e) },
      n
    ),
    render: r,
    state: { slot: "badge", variant: t }
  });
}
const st = {
  default: "text-muted-foreground bg-muted border-border",
  success: "text-emerald-700 bg-emerald-500/10 border-emerald-500/25 dark:text-emerald-400",
  error: "text-red-700 bg-red-500/10 border-red-500/25 dark:text-red-400",
  warning: "text-amber-700 bg-amber-500/10 border-amber-500/25 dark:text-amber-400",
  purple: "text-purple-700 bg-purple-500/10 border-purple-500/25 dark:text-purple-400",
  blue: "text-blue-700 bg-blue-500/10 border-blue-500/25 dark:text-blue-400",
  orange: "text-orange-700 bg-orange-500/10 border-orange-500/25 dark:text-orange-400",
  emerald: "text-emerald-700 bg-emerald-500/10 border-emerald-500/25 dark:text-emerald-400"
};
function dt({
  className: e,
  icon: t,
  variant: r = "default",
  children: n,
  ...i
}) {
  return /* @__PURE__ */ d(
    "div",
    {
      "data-slot": "tag",
      className: o(
        "inline-flex items-center gap-1.5 rounded-none border px-2.5 py-1 text-[0.625rem] font-semibold uppercase tracking-widest [&_svg]:h-3 [&_svg]:w-3",
        st[r],
        e
      ),
      ...i,
      children: [
        t && /* @__PURE__ */ a("span", { className: "flex-shrink-0", children: t }),
        /* @__PURE__ */ a("span", { className: "leading-none", children: n })
      ]
    }
  );
}
function ve(e) {
  return typeof e == "number" ? new Date(e < 1e10 ? e * 1e3 : e) : new Date(e);
}
function lt(e) {
  const t = Math.max(0, Math.floor(e / 1e3)), r = Math.floor(t / 3600), n = Math.floor(t % 3600 / 60), i = t % 60;
  return r > 0 ? `${String(r)}h ${String(n)}m` : n > 0 ? `${String(n)}m ${String(i)}s` : `${String(i)}s`;
}
function Sa({
  start: e,
  end: t,
  live: r = !1,
  className: n
}) {
  const [, i] = oe(0), s = !t && r;
  if (ie(() => {
    if (!s)
      return;
    const b = setInterval(() => {
      i((w) => w + 1);
    }, 1e3);
    return () => {
      clearInterval(b);
    };
  }, [s]), !e || !t && !r)
    return null;
  const c = ve(e), m = (t ? ve(t) : /* @__PURE__ */ new Date()).getTime() - c.getTime();
  return Number.isNaN(m) ? null : /* @__PURE__ */ a("span", { className: o("tabular-nums", n), children: lt(m) });
}
const ct = U(
  "group/button relative inline-flex shrink-0 items-center justify-center gap-2 whitespace-nowrap rounded-none border border-transparent bg-clip-padding text-xs font-semibold uppercase tracking-widest transition-all outline-none select-none cursor-pointer focus-visible:border-ring focus-visible:ring-2 focus-visible:ring-ring/30 active:not-aria-[haspopup]:translate-y-px disabled:pointer-events-none disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-2 aria-invalid:ring-destructive/20 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-3.5",
  {
    variants: {
      variant: {
        default: "bg-primary text-primary-foreground hover:bg-primary/80",
        primary: "bg-primary text-primary-foreground hover:bg-primary/80",
        secondary: "bg-secondary text-secondary-foreground hover:bg-[color-mix(in_oklch,var(--secondary),var(--foreground)_5%)] aria-expanded:bg-secondary aria-expanded:text-secondary-foreground",
        outline: "border-border bg-transparent hover:bg-muted hover:text-foreground aria-expanded:bg-muted aria-expanded:text-foreground dark:hover:bg-input/30",
        ghost: "hover:bg-muted hover:text-foreground aria-expanded:bg-muted aria-expanded:text-foreground dark:hover:bg-muted/50",
        destructive: "bg-destructive/10 text-destructive hover:bg-destructive/20 focus-visible:border-destructive/40 focus-visible:ring-destructive/20 dark:bg-destructive/20 dark:hover:bg-destructive/30 dark:focus-visible:ring-destructive/40",
        danger: "bg-destructive/10 text-destructive hover:bg-destructive/20 focus-visible:border-destructive/40 focus-visible:ring-destructive/20 dark:bg-destructive/20 dark:hover:bg-destructive/30 dark:focus-visible:ring-destructive/40",
        success: "bg-emerald-500/10 text-emerald-700 hover:bg-emerald-500/20 dark:bg-emerald-500/15 dark:text-emerald-400 dark:hover:bg-emerald-500/25",
        link: "text-primary underline underline-offset-4 hover:underline",
        icon: "border-border bg-transparent hover:bg-muted hover:text-foreground dark:hover:bg-input/30"
      },
      size: {
        default: "h-10 gap-1.5 px-6 has-data-[icon=inline-end]:pr-4 has-data-[icon=inline-start]:pl-4",
        xs: "h-7 gap-1 px-3 has-data-[icon=inline-end]:pr-2 has-data-[icon=inline-start]:pl-2 [&_svg:not([class*='size-'])]:size-3",
        sm: "h-9 gap-1 px-4 has-data-[icon=inline-end]:pr-3 has-data-[icon=inline-start]:pl-3",
        md: "h-10 gap-1.5 px-6 has-data-[icon=inline-end]:pr-4 has-data-[icon=inline-start]:pl-4",
        lg: "h-11 gap-1.5 px-8 has-data-[icon=inline-end]:pr-5 has-data-[icon=inline-start]:pl-5",
        icon: "size-10",
        "icon-xs": "size-7 [&_svg:not([class*='size-'])]:size-3",
        "icon-sm": "size-9",
        "icon-md": "size-10",
        "icon-lg": "size-11"
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default"
    }
  }
);
function q({
  className: e,
  variant: t = "default",
  size: r = "default",
  isLoading: n = !1,
  children: i,
  disabled: s,
  render: c,
  nativeButton: u,
  ...m
}) {
  const b = u ?? (c === void 0 || D.isValidElement(c) && c.type === "button");
  return /* @__PURE__ */ d(
    Ee,
    {
      "data-slot": "button",
      className: o(ct({ variant: t, size: r, className: e })),
      disabled: s === !0 || n,
      render: c,
      nativeButton: b,
      ...m,
      children: [
        n && /* @__PURE__ */ a(Oe, { className: "size-3.5 animate-spin" }),
        i
      ]
    }
  );
}
const ut = ({
  ref: e,
  className: t,
  active: r = !1,
  icon: n,
  children: i,
  "data-state": s,
  ...c
}) => {
  const u = r || s === "active";
  return /* @__PURE__ */ d(
    "button",
    {
      ref: e,
      "data-slot": "tab-button",
      "data-state": s,
      className: o(
        "group relative flex cursor-pointer items-center gap-2 px-4 py-2.5 text-xs font-semibold uppercase tracking-widest text-muted-foreground transition-colors duration-200 hover:text-foreground",
        u && "text-foreground",
        t
      ),
      ...c,
      children: [
        n && /* @__PURE__ */ a(n, { className: "size-3.5" }),
        i,
        /* @__PURE__ */ a(
          "span",
          {
            className: o(
              "absolute inset-x-0 bottom-0 h-px bg-foreground transition-transform duration-200",
              u ? "scale-x-100" : "scale-x-0"
            )
          }
        )
      ]
    }
  );
};
ut.displayName = "TabButton";
const pt = {
  sm: "h-9 text-xs",
  md: "h-10 text-sm",
  lg: "h-11 text-base"
};
function Ca({
  className: e,
  label: t,
  error: r,
  leftIcon: n,
  rightContent: i,
  inputSize: s = "md",
  "aria-invalid": c,
  ...u
}) {
  const m = !!r || c !== void 0 && c !== !1 && c !== "false";
  return /* @__PURE__ */ d("div", { className: "w-full", children: [
    t && /* @__PURE__ */ a("label", { className: "mb-2 block text-xs font-semibold uppercase tracking-widest text-muted-foreground", children: t }),
    /* @__PURE__ */ d(
      "div",
      {
        className: o(
          "flex items-center gap-2 border border-transparent border-b-input bg-transparent transition-[color,border-color] focus-within:border-b-ring",
          m && "border-b-destructive focus-within:border-b-destructive",
          e
        ),
        children: [
          n && /* @__PURE__ */ a(n, { className: "size-3.5 shrink-0 text-muted-foreground" }),
          /* @__PURE__ */ a(
            at,
            {
              "data-slot": "input",
              "aria-invalid": m || void 0,
              className: o(
                "w-full min-w-0 flex-1 border-0 bg-transparent px-0 py-1 outline-none placeholder:text-muted-foreground disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50",
                "file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground",
                pt[s]
              ),
              ...u
            }
          ),
          i && /* @__PURE__ */ a("div", { className: "shrink-0", children: i })
        ]
      }
    ),
    r && /* @__PURE__ */ a("p", { className: "mt-2 text-xs text-destructive", children: r })
  ] });
}
const gt = {
  sm: "w-8 h-8",
  md: "w-10 h-10",
  lg: "w-12 h-12"
}, ft = {
  sm: "[&>svg]:size-4",
  md: "[&>svg]:size-5",
  lg: "[&>svg]:size-6"
};
function mt({
  icon: e,
  children: t,
  size: r = "md",
  className: n,
  ...i
}) {
  return /* @__PURE__ */ d(
    Ge,
    {
      rounded: "xl",
      shadow: "md",
      className: o(
        gt[r],
        ft[r],
        "flex items-center justify-center dark:text-gray-300 text-gray-700",
        n
      ),
      ...i,
      children: [
        e,
        t
      ]
    }
  );
}
function Ta({
  icon: e,
  name: t,
  provider: r,
  modelId: n,
  capabilities: i,
  className: s,
  ...c
}) {
  return /* @__PURE__ */ d(
    qe,
    {
      className: o(
        "p-5",
        "dark:hover:border-white/[0.15] hover:border-gray-300",
        "transition-all duration-300",
        "group",
        s
      ),
      ...c,
      children: [
        /* @__PURE__ */ d("div", { className: "flex items-start justify-between mb-6", children: [
          /* @__PURE__ */ d("div", { className: "flex items-center gap-3", children: [
            /* @__PURE__ */ a(mt, { icon: e }),
            /* @__PURE__ */ d("div", { children: [
              /* @__PURE__ */ a("h3", { className: "dark:text-white text-gray-900 font-semibold text-sm", children: t }),
              /* @__PURE__ */ d("div", { className: "flex items-center gap-1.5 mt-0.5", children: [
                /* @__PURE__ */ a("span", { className: "dark:text-gray-500 text-gray-600 text-xs", children: r }),
                /* @__PURE__ */ a("span", { className: "dark:text-gray-600 text-gray-400 text-xs", children: "|" }),
                /* @__PURE__ */ d(
                  "a",
                  {
                    href: "#",
                    className: "dark:text-gray-500 text-gray-600 dark:hover:text-gray-300 hover:text-gray-900 text-xs flex items-center gap-1 transition-colors",
                    children: [
                      n,
                      /* @__PURE__ */ a(Ue, { className: "w-2.5 h-2.5" })
                    ]
                  }
                )
              ] })
            ] })
          ] }),
          /* @__PURE__ */ a(q, { variant: "icon", size: "icon-sm", children: /* @__PURE__ */ a(He, {}) })
        ] }),
        /* @__PURE__ */ a("div", { className: "flex flex-wrap gap-2", children: i.map((u, m) => /* @__PURE__ */ a(dt, { icon: u.icon, children: u.label }, m)) })
      ]
    }
  );
}
function _a({
  className: e,
  children: t,
  ...r
}) {
  return /* @__PURE__ */ d(
    B.Root,
    {
      "data-slot": "scroll-area",
      className: o("relative", e),
      ...r,
      children: [
        /* @__PURE__ */ a(
          B.Viewport,
          {
            "data-slot": "scroll-area-viewport",
            className: "size-full rounded-[inherit] transition-[color,box-shadow] outline-none focus-visible:ring-[3px] focus-visible:ring-ring/50 focus-visible:outline-1",
            children: t
          }
        ),
        /* @__PURE__ */ a(bt, {}),
        /* @__PURE__ */ a(B.Corner, {})
      ]
    }
  );
}
function bt({
  className: e,
  orientation: t = "vertical",
  ...r
}) {
  return /* @__PURE__ */ a(
    B.Scrollbar,
    {
      "data-slot": "scroll-area-scrollbar",
      "data-orientation": t,
      orientation: t,
      className: o(
        "flex touch-none p-px transition-colors select-none data-horizontal:h-2.5 data-horizontal:flex-col data-horizontal:border-t data-horizontal:border-t-transparent data-vertical:h-full data-vertical:w-2.5 data-vertical:border-l data-vertical:border-l-transparent",
        e
      ),
      ...r,
      children: /* @__PURE__ */ a(
        B.Thumb,
        {
          "data-slot": "scroll-area-thumb",
          className: "relative flex-1 rounded-none bg-border"
        }
      )
    }
  );
}
function ht({ ...e }) {
  return /* @__PURE__ */ a(x.Root, { "data-slot": "dropdown-menu", ...e });
}
function Ia({ ...e }) {
  return /* @__PURE__ */ a(x.Portal, { "data-slot": "dropdown-menu-portal", ...e });
}
function vt({ ...e }) {
  return /* @__PURE__ */ a(x.Trigger, { "data-slot": "dropdown-menu-trigger", ...e });
}
function $e({
  align: e = "start",
  alignOffset: t = 0,
  side: r = "bottom",
  sideOffset: n = 4,
  className: i,
  ...s
}) {
  return /* @__PURE__ */ a(x.Portal, { children: /* @__PURE__ */ a(
    x.Positioner,
    {
      className: "isolate z-50 outline-none",
      align: e,
      alignOffset: t,
      side: r,
      sideOffset: n,
      children: /* @__PURE__ */ a(
        x.Popup,
        {
          "data-slot": "dropdown-menu-content",
          className: o(
            "z-50 max-h-(--available-height) w-(--anchor-width) min-w-48 origin-(--transform-origin) overflow-x-hidden overflow-y-auto rounded-none bg-popover p-1.5 text-popover-foreground shadow-md ring-1 ring-foreground/10 duration-100 outline-none data-[side=bottom]:slide-in-from-top-2 data-[side=inline-end]:slide-in-from-left-2 data-[side=inline-start]:slide-in-from-right-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 data-open:animate-in data-open:fade-in-0 data-open:zoom-in-95 data-closed:animate-out data-closed:overflow-hidden data-closed:fade-out-0 data-closed:zoom-out-95",
            i
          ),
          ...s
        }
      )
    }
  ) });
}
const je = "px-3 py-2 text-xs font-semibold tracking-wider text-muted-foreground uppercase data-inset:pl-9.5";
function Aa({
  label: e,
  labelClassName: t,
  children: r,
  ...n
}) {
  return /* @__PURE__ */ d(x.Group, { "data-slot": "dropdown-menu-group", ...n, children: [
    e !== void 0 && /* @__PURE__ */ a(
      x.GroupLabel,
      {
        "data-slot": "dropdown-menu-group-label",
        className: o(je, t),
        children: e
      }
    ),
    r
  ] });
}
function xt({
  className: e,
  inset: t,
  ...r
}) {
  return /* @__PURE__ */ a(
    "div",
    {
      "data-slot": "dropdown-menu-label",
      "data-inset": t,
      className: o(je, e),
      ...r
    }
  );
}
function xe({
  className: e,
  inset: t,
  variant: r = "default",
  ...n
}) {
  return /* @__PURE__ */ a(
    x.Item,
    {
      "data-slot": "dropdown-menu-item",
      "data-inset": t,
      "data-variant": r,
      className: o(
        "group/dropdown-menu-item relative flex cursor-default items-center gap-2.5 rounded-none px-3 py-2 text-xs font-medium tracking-wider uppercase outline-hidden select-none focus:bg-accent focus:text-accent-foreground not-data-[variant=destructive]:focus:**:text-accent-foreground data-inset:pl-9.5 data-[variant=destructive]:text-destructive data-[variant=destructive]:focus:bg-destructive/10 data-[variant=destructive]:focus:text-destructive dark:data-[variant=destructive]:focus:bg-destructive/20 data-disabled:pointer-events-none data-disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-3.5 data-[variant=destructive]:*:[svg]:text-destructive",
        e
      ),
      ...n
    }
  );
}
function Da({ ...e }) {
  return /* @__PURE__ */ a(x.SubmenuRoot, { "data-slot": "dropdown-menu-sub", ...e });
}
function Pa({
  className: e,
  inset: t,
  children: r,
  ...n
}) {
  return /* @__PURE__ */ d(
    x.SubmenuTrigger,
    {
      "data-slot": "dropdown-menu-sub-trigger",
      "data-inset": t,
      className: o(
        "flex cursor-default items-center gap-2 rounded-none px-3 py-2 text-xs font-medium tracking-wider uppercase outline-hidden select-none focus:bg-accent focus:text-accent-foreground not-data-[variant=destructive]:focus:**:text-accent-foreground data-inset:pl-9.5 data-popup-open:bg-accent data-popup-open:text-accent-foreground data-open:bg-accent data-open:text-accent-foreground [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-3.5",
        e
      ),
      ...n,
      children: [
        r,
        /* @__PURE__ */ a(Je, { className: "ml-auto" })
      ]
    }
  );
}
function Ra({
  align: e = "start",
  alignOffset: t = -3,
  side: r = "right",
  sideOffset: n = 0,
  className: i,
  ...s
}) {
  return /* @__PURE__ */ a(
    $e,
    {
      "data-slot": "dropdown-menu-sub-content",
      className: o(
        "w-auto min-w-36 rounded-none bg-popover p-1.5 text-popover-foreground shadow-md ring-1 ring-foreground/10 duration-100 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 data-open:animate-in data-open:fade-in-0 data-open:zoom-in-95 data-closed:animate-out data-closed:fade-out-0 data-closed:zoom-out-95",
        i
      ),
      align: e,
      alignOffset: t,
      side: r,
      sideOffset: n,
      ...s
    }
  );
}
function $a({
  className: e,
  children: t,
  checked: r,
  inset: n,
  ...i
}) {
  return /* @__PURE__ */ d(
    x.CheckboxItem,
    {
      "data-slot": "dropdown-menu-checkbox-item",
      "data-inset": n,
      className: o(
        "relative flex cursor-default items-center gap-2.5 rounded-none py-2 pr-8 pl-3 text-xs font-medium tracking-wider uppercase outline-hidden select-none focus:bg-accent focus:text-accent-foreground focus:**:text-accent-foreground data-inset:pl-9.5 data-disabled:pointer-events-none data-disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-3.5",
        e
      ),
      checked: r,
      ...i,
      children: [
        /* @__PURE__ */ a(
          "span",
          {
            className: "pointer-events-none absolute right-2 flex items-center justify-center",
            "data-slot": "dropdown-menu-checkbox-item-indicator",
            children: /* @__PURE__ */ a(x.CheckboxItemIndicator, { children: /* @__PURE__ */ a(X, {}) })
          }
        ),
        t
      ]
    }
  );
}
function ja({ ...e }) {
  return /* @__PURE__ */ a(
    x.RadioGroup,
    {
      "data-slot": "dropdown-menu-radio-group",
      ...e
    }
  );
}
function La({
  className: e,
  children: t,
  inset: r,
  ...n
}) {
  return /* @__PURE__ */ d(
    x.RadioItem,
    {
      "data-slot": "dropdown-menu-radio-item",
      "data-inset": r,
      className: o(
        "relative flex cursor-default items-center gap-2.5 rounded-none py-2 pr-8 pl-3 text-xs font-medium tracking-wider uppercase outline-hidden select-none focus:bg-accent focus:text-accent-foreground focus:**:text-accent-foreground data-inset:pl-9.5 data-disabled:pointer-events-none data-disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-3.5",
        e
      ),
      ...n,
      children: [
        /* @__PURE__ */ a(
          "span",
          {
            className: "pointer-events-none absolute right-2 flex items-center justify-center",
            "data-slot": "dropdown-menu-radio-item-indicator",
            children: /* @__PURE__ */ a(x.RadioItemIndicator, { children: /* @__PURE__ */ a(X, {}) })
          }
        ),
        t
      ]
    }
  );
}
function yt({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    x.Separator,
    {
      "data-slot": "dropdown-menu-separator",
      className: o("-mx-1.5 my-1.5 h-px bg-border/50", e),
      ...t
    }
  );
}
function Ma({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    "span",
    {
      "data-slot": "dropdown-menu-shortcut",
      className: o(
        "ml-auto text-xs tracking-widest text-muted-foreground group-focus/dropdown-menu-item:text-accent-foreground",
        e
      ),
      ...t
    }
  );
}
const wt = o(
  "flex items-center justify-between gap-2 rounded-none border border-border bg-transparent px-3 py-2 text-xs font-semibold uppercase tracking-widest transition-colors",
  "hover:bg-muted focus:outline-none focus-visible:border-ring focus-visible:ring-2 focus-visible:ring-ring/30 data-popup-open:bg-muted"
);
function Va({
  items: e,
  children: t,
  triggerLabel: r,
  placeholder: n = "Select...",
  triggerIcon: i,
  value: s,
  onValueChange: c,
  align: u = "start",
  side: m = "bottom",
  width: b = "auto",
  triggerClassName: w,
  contentClassName: N
}) {
  const v = D.useMemo(() => s === void 0 ? null : e.find(
    (p) => p.type === "option" && p.value === s
  ), [e, s]), $ = (v == null ? void 0 : v.label) ?? r ?? n, _ = (v == null ? void 0 : v.icon) ?? i, z = D.useCallback(
    (p) => {
      p.type === "option" && c ? c(p.value) : p.type === "item" && p.onClick && p.onClick();
    },
    [c]
  ), I = D.useCallback(
    (p, j) => {
      if (p.type === "separator")
        return /* @__PURE__ */ a(yt, {}, `separator-${String(j)}`);
      if (p.type === "label")
        return /* @__PURE__ */ a(xt, { children: p.label }, `label-${String(j)}`);
      const S = p.icon, H = p.type === "option" ? p.value === s : p.selected, f = p.type === "item" && p.variant === "destructive", g = /* @__PURE__ */ d(Ie, { children: [
        S ? /* @__PURE__ */ a(S, { className: "size-3.5 shrink-0" }) : H ? /* @__PURE__ */ a(ae, { className: "size-3.5 shrink-0" }) : /* @__PURE__ */ a("span", { className: "w-3.5 shrink-0" }),
        /* @__PURE__ */ d("div", { className: "min-w-0 flex-1", children: [
          /* @__PURE__ */ a("div", { className: "truncate", children: p.label }),
          p.subtitle && /* @__PURE__ */ a("div", { className: "truncate text-[0.625rem] font-normal normal-case tracking-normal text-muted-foreground", children: p.subtitle })
        ] }),
        S && H && /* @__PURE__ */ a(ae, { className: "size-3.5 shrink-0" })
      ] });
      return p.type === "item" && p.href ? /* @__PURE__ */ a(
        xe,
        {
          variant: f ? "destructive" : "default",
          disabled: p.disabled,
          render: /* @__PURE__ */ a(
            "a",
            {
              href: p.href,
              target: p.external ? "_blank" : void 0,
              rel: p.external ? "noopener noreferrer" : void 0
            }
          ),
          children: g
        },
        `item-${String(j)}`
      ) : /* @__PURE__ */ a(
        xe,
        {
          variant: f ? "destructive" : "default",
          disabled: p.disabled,
          onClick: () => {
            z(p);
          },
          children: g
        },
        `item-${String(j)}`
      );
    },
    [s, z]
  ), K = D.useMemo(() => {
    if (typeof b == "number")
      return { width: `${String(b)}px` };
  }, [b]);
  return /* @__PURE__ */ d(ht, { children: [
    /* @__PURE__ */ a(
      vt,
      {
        render: t ?? /* @__PURE__ */ d("button", { className: o(wt, w), children: [
          /* @__PURE__ */ d("span", { className: "flex items-center gap-2", children: [
            _ && /* @__PURE__ */ a(_, { className: "size-3.5" }),
            /* @__PURE__ */ a("span", { className: "truncate", children: $ })
          ] }),
          /* @__PURE__ */ a(Xe, { className: "size-3.5 shrink-0 text-muted-foreground transition-transform duration-200 data-popup-open:rotate-180" })
        ] })
      }
    ),
    /* @__PURE__ */ a(
      $e,
      {
        align: u,
        side: m,
        sideOffset: 8,
        className: o(b === "auto" && "w-auto", N),
        style: K,
        children: e.map(I)
      }
    )
  ] });
}
function Fa({ ...e }) {
  return /* @__PURE__ */ a(h.Root, { "data-slot": "dialog", ...e });
}
function Ga({ ...e }) {
  return /* @__PURE__ */ a(h.Trigger, { "data-slot": "dialog-trigger", ...e });
}
function kt({ ...e }) {
  return /* @__PURE__ */ a(h.Portal, { "data-slot": "dialog-portal", ...e });
}
function qa({ ...e }) {
  return /* @__PURE__ */ a(h.Close, { "data-slot": "dialog-close", ...e });
}
function Nt({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    h.Backdrop,
    {
      "data-slot": "dialog-overlay",
      className: o(
        "fixed inset-0 isolate z-50 bg-black/20 duration-100 supports-backdrop-filter:backdrop-blur-sm data-open:animate-in data-open:fade-in-0 data-closed:animate-out data-closed:fade-out-0",
        e
      ),
      ...t
    }
  );
}
function Ba({
  className: e,
  children: t,
  showCloseButton: r = !0,
  ...n
}) {
  return /* @__PURE__ */ d(kt, { children: [
    /* @__PURE__ */ a(Nt, {}),
    /* @__PURE__ */ d(
      h.Popup,
      {
        "data-slot": "dialog-content",
        className: o(
          "fixed top-1/2 left-1/2 z-50 grid w-full max-w-[calc(100%-2rem)] -translate-x-1/2 -translate-y-1/2 gap-6 rounded-none bg-popover p-6 text-sm text-popover-foreground shadow-md ring-1 ring-foreground/10 duration-100 outline-none sm:max-w-md data-open:animate-in data-open:fade-in-0 data-open:zoom-in-95 data-closed:animate-out data-closed:fade-out-0 data-closed:zoom-out-95",
          e
        ),
        ...n,
        children: [
          t,
          r && /* @__PURE__ */ d(
            h.Close,
            {
              "data-slot": "dialog-close",
              render: /* @__PURE__ */ a(
                q,
                {
                  variant: "ghost",
                  className: "absolute top-5 right-5 bg-secondary",
                  size: "icon-sm"
                }
              ),
              children: [
                /* @__PURE__ */ a(De, {}),
                /* @__PURE__ */ a("span", { className: "sr-only", children: "Close" })
              ]
            }
          )
        ]
      }
    )
  ] });
}
function Ea({ className: e, ...t }) {
  return /* @__PURE__ */ a(
    "div",
    {
      "data-slot": "dialog-header",
      className: o("flex flex-col gap-2", e),
      ...t
    }
  );
}
function Oa({
  className: e,
  showCloseButton: t = !1,
  children: r,
  ...n
}) {
  return /* @__PURE__ */ d(
    "div",
    {
      "data-slot": "dialog-footer",
      className: o(
        "flex flex-col-reverse gap-2 sm:flex-row sm:justify-end",
        e
      ),
      ...n,
      children: [
        r,
        t && /* @__PURE__ */ a(h.Close, { render: /* @__PURE__ */ a(q, { variant: "outline" }), children: "Close" })
      ]
    }
  );
}
function Ua({ className: e, ...t }) {
  return /* @__PURE__ */ a(
    h.Title,
    {
      "data-slot": "dialog-title",
      className: o(
        "font-heading text-lg leading-none font-semibold tracking-wider uppercase",
        e
      ),
      ...t
    }
  );
}
function Ha({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    h.Description,
    {
      "data-slot": "dialog-description",
      className: o(
        "mt-0.5 text-sm leading-relaxed text-muted-foreground *:[a]:underline *:[a]:underline-offset-3 *:[a]:hover:text-foreground",
        e
      ),
      ...t
    }
  );
}
function Ja({ ...e }) {
  return /* @__PURE__ */ a(T.Root, { "data-slot": "alert-dialog", ...e });
}
function Xa({ ...e }) {
  return /* @__PURE__ */ a(T.Trigger, { "data-slot": "alert-dialog-trigger", ...e });
}
function zt({ ...e }) {
  return /* @__PURE__ */ a(T.Portal, { "data-slot": "alert-dialog-portal", ...e });
}
function St({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    T.Backdrop,
    {
      "data-slot": "alert-dialog-overlay",
      className: o(
        "fixed inset-0 isolate z-50 bg-black/20 duration-100 supports-backdrop-filter:backdrop-blur-sm data-open:animate-in data-open:fade-in-0 data-closed:animate-out data-closed:fade-out-0",
        e
      ),
      ...t
    }
  );
}
function Wa({
  className: e,
  size: t = "default",
  ...r
}) {
  return /* @__PURE__ */ d(zt, { children: [
    /* @__PURE__ */ a(St, {}),
    /* @__PURE__ */ a(
      T.Popup,
      {
        "data-slot": "alert-dialog-content",
        "data-size": t,
        className: o(
          "group/alert-dialog-content fixed top-1/2 left-1/2 z-50 grid w-full -translate-x-1/2 -translate-y-1/2 gap-6 rounded-none bg-popover p-6 text-popover-foreground shadow-md ring-1 ring-foreground/10 duration-100 outline-none data-[size=default]:max-w-xs data-[size=sm]:max-w-xs data-[size=default]:sm:max-w-md data-open:animate-in data-open:fade-in-0 data-open:zoom-in-95 data-closed:animate-out data-closed:fade-out-0 data-closed:zoom-out-95",
          e
        ),
        ...r
      }
    )
  ] });
}
function Ya({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    "div",
    {
      "data-slot": "alert-dialog-header",
      className: o(
        "grid grid-rows-[auto_1fr] place-items-center gap-2 text-center has-data-[slot=alert-dialog-media]:grid-rows-[auto_auto_1fr] has-data-[slot=alert-dialog-media]:gap-x-6 sm:group-data-[size=default]/alert-dialog-content:place-items-start sm:group-data-[size=default]/alert-dialog-content:text-left sm:group-data-[size=default]/alert-dialog-content:has-data-[slot=alert-dialog-media]:grid-rows-[auto_1fr]",
        e
      ),
      ...t
    }
  );
}
function Ka({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    "div",
    {
      "data-slot": "alert-dialog-footer",
      className: o(
        "flex flex-col-reverse gap-2 group-data-[size=sm]/alert-dialog-content:grid group-data-[size=sm]/alert-dialog-content:grid-cols-2 sm:flex-row sm:justify-end",
        e
      ),
      ...t
    }
  );
}
function Qa({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    T.Title,
    {
      "data-slot": "alert-dialog-title",
      className: o(
        "font-heading text-lg font-semibold tracking-wider uppercase sm:group-data-[size=default]/alert-dialog-content:group-has-data-[slot=alert-dialog-media]/alert-dialog-content:col-start-2",
        e
      ),
      ...t
    }
  );
}
function Za({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    T.Description,
    {
      "data-slot": "alert-dialog-description",
      className: o(
        "mt-0.5 text-sm leading-relaxed text-balance text-muted-foreground md:text-pretty *:[a]:underline *:[a]:underline-offset-3 *:[a]:hover:text-foreground",
        e
      ),
      ...t
    }
  );
}
function er({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    q,
    {
      "data-slot": "alert-dialog-action",
      className: o(e),
      ...t
    }
  );
}
function tr({
  className: e,
  variant: t = "outline",
  size: r = "default",
  ...n
}) {
  return /* @__PURE__ */ a(
    T.Close,
    {
      "data-slot": "alert-dialog-cancel",
      className: o(e),
      render: /* @__PURE__ */ a(q, { variant: t, size: r }),
      ...n
    }
  );
}
function re(e, t = []) {
  if (Array.isArray(e)) {
    for (const r of e)
      re(r, t);
    return t;
  }
  return D.isValidElement(
    e
  ) ? e.type === Ct ? (t.push({ value: e.props.value, label: e.props.children }), t) : re(e.props.children, t) : t;
}
function ar({ onValueChange: e, items: t, children: r, ...n }) {
  const i = D.useMemo(
    () => t ?? re(r),
    [t, r]
  );
  return /* @__PURE__ */ a(
    y.Root,
    {
      ...n,
      items: i,
      onValueChange: (s) => {
        e == null || e(s ?? "");
      },
      children: r
    }
  );
}
function rr({ className: e, ...t }) {
  return /* @__PURE__ */ a(
    y.Group,
    {
      "data-slot": "select-group",
      className: o("scroll-my-1.5 p-1.5", e),
      ...t
    }
  );
}
function nr({ className: e, ...t }) {
  return /* @__PURE__ */ a(
    y.Value,
    {
      "data-slot": "select-value",
      className: o("flex flex-1 text-left", e),
      ...t
    }
  );
}
function or({
  className: e,
  size: t = "default",
  children: r,
  ...n
}) {
  return /* @__PURE__ */ d(
    y.Trigger,
    {
      "data-slot": "select-trigger",
      "data-size": t,
      className: o(
        "flex w-fit items-center justify-between gap-1.5 rounded-none border border-transparent border-b-input bg-transparent px-0 py-2 text-sm whitespace-nowrap transition-[color,border-color] outline-none focus-visible:border-b-ring disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-b-destructive data-placeholder:text-muted-foreground data-[size=default]:h-10 data-[size=sm]:h-9 *:data-[slot=select-value]:line-clamp-1 *:data-[slot=select-value]:flex *:data-[slot=select-value]:items-center *:data-[slot=select-value]:gap-1.5 dark:aria-invalid:border-b-destructive/50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-3.5",
        e
      ),
      ...n,
      children: [
        r,
        /* @__PURE__ */ a(
          y.Icon,
          {
            render: /* @__PURE__ */ a(W, { className: "pointer-events-none size-3.5 text-muted-foreground" })
          }
        )
      ]
    }
  );
}
function ir({
  className: e,
  children: t,
  side: r = "bottom",
  sideOffset: n = 4,
  align: i = "center",
  alignOffset: s = 0,
  alignItemWithTrigger: c = !0,
  ...u
}) {
  return /* @__PURE__ */ a(y.Portal, { children: /* @__PURE__ */ a(
    y.Positioner,
    {
      side: r,
      sideOffset: n,
      align: i,
      alignOffset: s,
      alignItemWithTrigger: c,
      className: "isolate z-50",
      children: /* @__PURE__ */ d(
        y.Popup,
        {
          "data-slot": "select-content",
          "data-align-trigger": c,
          className: o(
            "relative isolate z-50 max-h-(--available-height) w-(--anchor-width) min-w-36 origin-(--transform-origin) overflow-x-hidden overflow-y-auto rounded-none bg-popover text-popover-foreground shadow-md ring-1 ring-foreground/10 duration-100 data-[align-trigger=true]:animate-none data-[side=bottom]:slide-in-from-top-2 data-[side=inline-end]:slide-in-from-left-2 data-[side=inline-start]:slide-in-from-right-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 data-open:animate-in data-open:fade-in-0 data-open:zoom-in-95 data-closed:animate-out data-closed:fade-out-0 data-closed:zoom-out-95",
            e
          ),
          ...u,
          children: [
            /* @__PURE__ */ a(Tt, {}),
            /* @__PURE__ */ a(y.List, { children: t }),
            /* @__PURE__ */ a(_t, {})
          ]
        }
      )
    }
  ) });
}
function sr({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    y.GroupLabel,
    {
      "data-slot": "select-label",
      className: o(
        "px-3 py-2 text-xs font-semibold tracking-wider text-muted-foreground uppercase",
        e
      ),
      ...t
    }
  );
}
function Ct({
  className: e,
  children: t,
  ...r
}) {
  return /* @__PURE__ */ d(
    y.Item,
    {
      "data-slot": "select-item",
      className: o(
        "relative flex w-full cursor-default items-center gap-2.5 rounded-none py-2 pr-8 pl-3 text-sm outline-hidden select-none focus:bg-accent focus:text-accent-foreground not-data-[variant=destructive]:focus:**:text-accent-foreground data-disabled:pointer-events-none data-disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-3.5 *:[span]:last:flex *:[span]:last:items-center *:[span]:last:gap-2",
        e
      ),
      ...r,
      children: [
        /* @__PURE__ */ a(y.ItemText, { className: "flex flex-1 shrink-0 gap-2 whitespace-nowrap", children: t }),
        /* @__PURE__ */ a(
          y.ItemIndicator,
          {
            render: /* @__PURE__ */ a("span", { className: "pointer-events-none absolute right-2 flex size-4 items-center justify-center" }),
            children: /* @__PURE__ */ a(X, { className: "pointer-events-none" })
          }
        )
      ]
    }
  );
}
function dr({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    y.Separator,
    {
      "data-slot": "select-separator",
      className: o(
        "pointer-events-none -mx-1.5 my-1.5 h-px bg-border/50",
        e
      ),
      ...t
    }
  );
}
function Tt({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    y.ScrollUpArrow,
    {
      "data-slot": "select-scroll-up-button",
      className: o(
        "top-0 z-10 flex w-full cursor-default items-center justify-center bg-popover py-1 [&_svg:not([class*='size-'])]:size-3.5",
        e
      ),
      ...t,
      children: /* @__PURE__ */ a(Pe, {})
    }
  );
}
function _t({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    y.ScrollDownArrow,
    {
      "data-slot": "select-scroll-down-button",
      className: o(
        "bottom-0 z-10 flex w-full cursor-default items-center justify-center bg-popover py-1 [&_svg:not([class*='size-'])]:size-3.5",
        e
      ),
      ...t,
      children: /* @__PURE__ */ a(W, {})
    }
  );
}
function lr({
  delay: e = 0,
  ...t
}) {
  return /* @__PURE__ */ a(
    P.Provider,
    {
      "data-slot": "tooltip-provider",
      delay: e,
      ...t
    }
  );
}
function cr({ ...e }) {
  return /* @__PURE__ */ a(P.Root, { "data-slot": "tooltip", ...e });
}
function ur({ ...e }) {
  return /* @__PURE__ */ a(P.Trigger, { "data-slot": "tooltip-trigger", ...e });
}
function pr({
  className: e,
  side: t = "top",
  sideOffset: r = 4,
  align: n = "center",
  alignOffset: i = 0,
  children: s,
  ...c
}) {
  return /* @__PURE__ */ a(P.Portal, { children: /* @__PURE__ */ a(
    P.Positioner,
    {
      align: n,
      alignOffset: i,
      side: t,
      sideOffset: r,
      className: "isolate z-50",
      children: /* @__PURE__ */ d(
        P.Popup,
        {
          "data-slot": "tooltip-content",
          className: o(
            "z-50 inline-flex w-fit max-w-xs origin-(--transform-origin) items-center gap-1.5 rounded-none bg-foreground px-3 py-1.5 text-xs text-background has-data-[slot=kbd]:pr-1.5 data-[side=bottom]:slide-in-from-top-2 data-[side=inline-end]:slide-in-from-left-2 data-[side=inline-start]:slide-in-from-right-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 **:data-[slot=kbd]:relative **:data-[slot=kbd]:isolate **:data-[slot=kbd]:z-50 **:data-[slot=kbd]:rounded-none data-[state=delayed-open]:animate-in data-[state=delayed-open]:fade-in-0 data-[state=delayed-open]:zoom-in-95 data-open:animate-in data-open:fade-in-0 data-open:zoom-in-95 data-closed:animate-out data-closed:fade-out-0 data-closed:zoom-out-95",
            e
          ),
          ...c,
          children: [
            s,
            /* @__PURE__ */ a(P.Arrow, { className: "z-50 size-2.5 translate-y-[calc(-50%-2px)] rotate-45 rounded-none bg-foreground fill-foreground data-[side=bottom]:top-1 data-[side=inline-end]:top-1/2! data-[side=inline-end]:-left-1 data-[side=inline-end]:translate-x-[1.5px] data-[side=inline-end]:-translate-y-1/2 data-[side=inline-start]:top-1/2! data-[side=inline-start]:-right-1 data-[side=inline-start]:translate-x-[-1.5px] data-[side=inline-start]:-translate-y-1/2 data-[side=left]:top-1/2! data-[side=left]:-right-1 data-[side=left]:-translate-y-1/2 data-[side=right]:top-1/2! data-[side=right]:-left-1 data-[side=right]:-translate-y-1/2 data-[side=top]:-bottom-2.5" })
          ]
        }
      )
    }
  ) });
}
function gr({ className: e, ...t }) {
  return /* @__PURE__ */ a(
    ge.Root,
    {
      "data-slot": "checkbox",
      className: o(
        "peer relative flex size-4.5 shrink-0 items-center justify-center rounded-none border border-input bg-transparent transition-shadow outline-none group-has-disabled/field:opacity-50 after:absolute after:-inset-x-3 after:-inset-y-2 focus-visible:border-ring focus-visible:ring-2 focus-visible:ring-ring/30 disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-2 aria-invalid:ring-destructive/20 aria-invalid:aria-checked:border-primary dark:aria-invalid:border-destructive/50 dark:aria-invalid:ring-destructive/40 data-checked:border-primary data-checked:bg-primary data-checked:text-primary-foreground dark:data-checked:bg-primary",
        e
      ),
      ...t,
      children: /* @__PURE__ */ a(
        ge.Indicator,
        {
          "data-slot": "checkbox-indicator",
          className: "grid place-content-center text-current transition-none [&>svg]:size-3.5",
          children: /* @__PURE__ */ a(X, {})
        }
      )
    }
  );
}
function fr({ className: e, ...t }) {
  return /* @__PURE__ */ a(
    rt,
    {
      "data-slot": "radio-group",
      className: o("grid w-full gap-3", e),
      ...t
    }
  );
}
function mr({ className: e, ...t }) {
  return /* @__PURE__ */ a(
    fe.Root,
    {
      "data-slot": "radio-group-item",
      className: o(
        "group/radio-group-item peer relative flex aspect-square size-4.5 shrink-0 rounded-full border border-input bg-transparent outline-none after:absolute after:-inset-x-3 after:-inset-y-2 focus-visible:border-ring focus-visible:ring-2 focus-visible:ring-ring/30 disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-2 aria-invalid:ring-destructive/20 aria-invalid:aria-checked:border-foreground dark:aria-invalid:border-destructive/50 dark:aria-invalid:ring-destructive/40 data-checked:border-foreground",
        e
      ),
      ...t,
      children: /* @__PURE__ */ a(
        fe.Indicator,
        {
          "data-slot": "radio-group-indicator",
          className: "flex size-4.5 items-center justify-center",
          children: /* @__PURE__ */ a("span", { className: "absolute top-1/2 left-1/2 size-2 -translate-x-1/2 -translate-y-1/2 rounded-full bg-foreground" })
        }
      )
    }
  );
}
function br({
  className: e,
  size: t = "default",
  ...r
}) {
  return /* @__PURE__ */ a(
    me.Root,
    {
      "data-slot": "switch",
      "data-size": t,
      className: o(
        "peer group/switch relative inline-flex shrink-0 items-center rounded-none border transition-all outline-none after:absolute after:-inset-x-3 after:-inset-y-2 focus-visible:border-ring focus-visible:ring-2 focus-visible:ring-ring/30 aria-invalid:border-destructive aria-invalid:ring-2 aria-invalid:ring-destructive/20 data-[size=default]:h-4.5 data-[size=default]:w-8.25 data-[size=sm]:h-3.5 data-[size=sm]:w-6.25 dark:aria-invalid:border-destructive/50 dark:aria-invalid:ring-destructive/40 data-checked:border-primary data-checked:bg-primary data-unchecked:border-input/50 data-unchecked:bg-input data-disabled:cursor-not-allowed data-disabled:opacity-50",
        e
      ),
      ...r,
      children: /* @__PURE__ */ a(
        me.Thumb,
        {
          "data-slot": "switch-thumb",
          className: "pointer-events-none block bg-background ring-0 transition-transform group-data-[size=default]/switch:size-3.5 group-data-[size=sm]/switch:size-2.5 data-checked:translate-x-[calc(100%+2px)] dark:data-checked:bg-primary-foreground data-unchecked:translate-x-0.25 dark:data-unchecked:bg-foreground"
        }
      )
    }
  );
}
function hr({
  className: e,
  orientation: t = "horizontal",
  ...r
}) {
  return /* @__PURE__ */ a(
    Y.Root,
    {
      "data-slot": "tabs",
      "data-orientation": t,
      className: o(
        "group/tabs flex gap-2 data-horizontal:flex-col",
        e
      ),
      ...r
    }
  );
}
const It = U(
  "group/tabs-list inline-flex w-fit items-center justify-center p-1 text-muted-foreground group-data-horizontal/tabs:h-10 group-data-vertical/tabs:h-fit group-data-vertical/tabs:flex-col",
  {
    variants: {
      variant: {
        default: "bg-muted",
        line: "gap-1 bg-transparent"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
);
function vr({
  className: e,
  variant: t = "default",
  ...r
}) {
  return /* @__PURE__ */ a(
    Y.List,
    {
      "data-slot": "tabs-list",
      "data-variant": t,
      className: o(It({ variant: t }), e),
      ...r
    }
  );
}
function xr({ className: e, ...t }) {
  return /* @__PURE__ */ a(
    Y.Tab,
    {
      "data-slot": "tabs-trigger",
      className: o(
        "relative inline-flex h-[calc(100%-1px)] flex-1 items-center justify-center gap-2 border border-transparent px-4 py-1.5 text-xs font-semibold tracking-wider whitespace-nowrap text-foreground/60 uppercase transition-all group-data-vertical/tabs:w-full group-data-vertical/tabs:justify-start group-data-vertical/tabs:px-4 group-data-vertical/tabs:py-2 hover:text-foreground focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 focus-visible:outline-1 focus-visible:outline-ring disabled:pointer-events-none disabled:opacity-50 has-data-[icon=inline-end]:pr-2.5 has-data-[icon=inline-start]:pl-2.5 aria-disabled:pointer-events-none aria-disabled:opacity-50 dark:text-muted-foreground dark:hover:text-foreground [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-3.5",
        "group-data-[variant=line]/tabs-list:bg-transparent group-data-[variant=line]/tabs-list:data-active:bg-transparent dark:group-data-[variant=line]/tabs-list:data-active:border-transparent dark:group-data-[variant=line]/tabs-list:data-active:bg-transparent",
        "data-active:bg-background data-active:text-foreground dark:data-active:border-input dark:data-active:bg-input/30 dark:data-active:text-foreground",
        "after:absolute after:bg-foreground after:opacity-0 after:transition-opacity group-data-horizontal/tabs:after:inset-x-0 group-data-horizontal/tabs:after:bottom-[-5px] group-data-horizontal/tabs:after:h-0.5 group-data-vertical/tabs:after:inset-y-0 group-data-vertical/tabs:after:-right-1 group-data-vertical/tabs:after:w-0.5 group-data-[variant=line]/tabs-list:data-active:after:opacity-100",
        e
      ),
      ...t
    }
  );
}
function yr({ className: e, ...t }) {
  return /* @__PURE__ */ a(
    Y.Panel,
    {
      "data-slot": "tabs-content",
      className: o("flex-1 text-sm outline-none", e),
      ...t
    }
  );
}
function wr({
  className: e,
  children: t,
  value: r,
  ...n
}) {
  return /* @__PURE__ */ d(
    se.Root,
    {
      value: r,
      "data-slot": "progress",
      className: o("flex flex-wrap gap-3", e),
      ...n,
      children: [
        t,
        /* @__PURE__ */ a(At, { children: /* @__PURE__ */ a(Dt, {}) })
      ]
    }
  );
}
function At({ className: e, ...t }) {
  return /* @__PURE__ */ a(
    se.Track,
    {
      className: o(
        "relative flex h-0.5 w-full items-center overflow-x-hidden rounded-none bg-muted",
        e
      ),
      "data-slot": "progress-track",
      ...t
    }
  );
}
function Dt({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    se.Indicator,
    {
      "data-slot": "progress-indicator",
      className: o("h-full bg-primary transition-all", e),
      ...t
    }
  );
}
function kr({
  className: e,
  orientation: t = "horizontal",
  ...r
}) {
  return /* @__PURE__ */ a(
    nt,
    {
      "data-slot": "separator",
      orientation: t,
      className: o(
        "shrink-0 bg-border data-horizontal:h-px data-horizontal:w-full data-vertical:w-px data-vertical:self-stretch",
        e
      ),
      ...r
    }
  );
}
function Nr({ className: e, ...t }) {
  return /* @__PURE__ */ a(
    "label",
    {
      "data-slot": "label",
      className: o(
        "flex items-center gap-2 text-xs font-semibold tracking-wide uppercase select-none group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50 peer-data-[slot=checkbox]:text-sm peer-data-[slot=checkbox]:font-normal peer-data-[slot=checkbox]:tracking-normal peer-data-[slot=checkbox]:normal-case peer-data-[slot=radio-group-item]:text-sm peer-data-[slot=radio-group-item]:font-normal peer-data-[slot=radio-group-item]:tracking-normal peer-data-[slot=radio-group-item]:normal-case peer-data-[slot=switch]:text-sm peer-data-[slot=switch]:font-normal peer-data-[slot=switch]:tracking-normal peer-data-[slot=switch]:normal-case",
        e
      ),
      ...t
    }
  );
}
function zr({ className: e, ...t }) {
  return /* @__PURE__ */ a(
    "textarea",
    {
      "data-slot": "textarea",
      className: o(
        "flex field-sizing-content min-h-16 w-full resize-none rounded-none border border-transparent border-b-input bg-transparent px-0 py-3 text-base transition-[color,border-color] outline-none placeholder:text-muted-foreground focus-visible:border-b-ring disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-b-destructive md:text-sm dark:aria-invalid:border-b-destructive/50",
        e
      ),
      ...t
    }
  );
}
function Sr({ className: e, ...t }) {
  return /* @__PURE__ */ a(
    O.Root,
    {
      "data-slot": "accordion",
      className: o("flex w-full flex-col", e),
      ...t
    }
  );
}
function Cr({ className: e, ...t }) {
  return /* @__PURE__ */ a(
    O.Item,
    {
      "data-slot": "accordion-item",
      className: o("not-last:border-b", e),
      ...t
    }
  );
}
function Tr({
  className: e,
  children: t,
  ...r
}) {
  return /* @__PURE__ */ a(O.Header, { className: "flex", children: /* @__PURE__ */ d(
    O.Trigger,
    {
      "data-slot": "accordion-trigger",
      className: o(
        "group/accordion-trigger relative flex flex-1 items-start justify-between gap-6 rounded-none border border-transparent py-4 text-left text-sm font-semibold transition-all outline-none hover:underline focus-visible:border-ring focus-visible:ring-2 focus-visible:ring-ring/30 aria-disabled:pointer-events-none aria-disabled:opacity-50 **:data-[slot=accordion-trigger-icon]:ml-auto **:data-[slot=accordion-trigger-icon]:size-3.5 **:data-[slot=accordion-trigger-icon]:text-muted-foreground",
        e
      ),
      ...r,
      children: [
        t,
        /* @__PURE__ */ a(
          W,
          {
            "data-slot": "accordion-trigger-icon",
            className: "pointer-events-none shrink-0 group-aria-expanded/accordion-trigger:hidden"
          }
        ),
        /* @__PURE__ */ a(
          Pe,
          {
            "data-slot": "accordion-trigger-icon",
            className: "pointer-events-none hidden shrink-0 group-aria-expanded/accordion-trigger:inline"
          }
        )
      ]
    }
  ) });
}
function _r({
  className: e,
  children: t,
  ...r
}) {
  return /* @__PURE__ */ a(
    O.Panel,
    {
      "data-slot": "accordion-content",
      className: "overflow-hidden text-sm data-open:animate-accordion-down data-closed:animate-accordion-up",
      ...r,
      children: /* @__PURE__ */ a(
        "div",
        {
          className: o(
            "h-(--accordion-panel-height) pt-0 pb-4 data-ending-style:h-0 data-starting-style:h-0 [&_a]:underline [&_a]:underline-offset-3 [&_a]:hover:text-foreground [&_p:not(:last-child)]:mb-4",
            e
          ),
          children: t
        }
      )
    }
  );
}
function Ir({ ...e }) {
  return /* @__PURE__ */ a(h.Root, { "data-slot": "sheet", ...e });
}
function Ar({ ...e }) {
  return /* @__PURE__ */ a(h.Trigger, { "data-slot": "sheet-trigger", ...e });
}
function Dr({ ...e }) {
  return /* @__PURE__ */ a(h.Close, { "data-slot": "sheet-close", ...e });
}
function Pt({ ...e }) {
  return /* @__PURE__ */ a(h.Portal, { "data-slot": "sheet-portal", ...e });
}
function Rt({ className: e, ...t }) {
  return /* @__PURE__ */ a(
    h.Backdrop,
    {
      "data-slot": "sheet-overlay",
      className: o(
        "fixed inset-0 z-50 bg-black/20 transition-opacity duration-150 data-ending-style:opacity-0 data-starting-style:opacity-0 supports-backdrop-filter:backdrop-blur-sm",
        e
      ),
      ...t
    }
  );
}
function Pr({
  className: e,
  children: t,
  side: r = "right",
  showCloseButton: n = !0,
  ...i
}) {
  return /* @__PURE__ */ d(Pt, { children: [
    /* @__PURE__ */ a(Rt, {}),
    /* @__PURE__ */ d(
      h.Popup,
      {
        "data-slot": "sheet-content",
        "data-side": r,
        className: o(
          "fixed z-50 flex flex-col bg-popover bg-clip-padding text-sm text-popover-foreground shadow-md transition duration-200 ease-in-out data-ending-style:opacity-0 data-starting-style:opacity-0 data-[side=bottom]:inset-x-0 data-[side=bottom]:bottom-0 data-[side=bottom]:h-auto data-[side=bottom]:border-t data-[side=bottom]:data-ending-style:translate-y-[2.5rem] data-[side=bottom]:data-starting-style:translate-y-[2.5rem] data-[side=left]:inset-y-0 data-[side=left]:left-0 data-[side=left]:h-full data-[side=left]:w-3/4 data-[side=left]:border-r data-[side=left]:data-ending-style:translate-x-[-2.5rem] data-[side=left]:data-starting-style:translate-x-[-2.5rem] data-[side=right]:inset-y-0 data-[side=right]:right-0 data-[side=right]:h-full data-[side=right]:w-3/4 data-[side=right]:border-l data-[side=right]:data-ending-style:translate-x-[2.5rem] data-[side=right]:data-starting-style:translate-x-[2.5rem] data-[side=top]:inset-x-0 data-[side=top]:top-0 data-[side=top]:h-auto data-[side=top]:border-b data-[side=top]:data-ending-style:translate-y-[-2.5rem] data-[side=top]:data-starting-style:translate-y-[-2.5rem] data-[side=left]:sm:max-w-sm data-[side=right]:sm:max-w-sm",
          e
        ),
        ...i,
        children: [
          t,
          n && /* @__PURE__ */ d(
            h.Close,
            {
              "data-slot": "sheet-close",
              render: /* @__PURE__ */ a(
                q,
                {
                  variant: "ghost",
                  className: "absolute top-4 right-4 bg-secondary",
                  size: "icon-sm"
                }
              ),
              children: [
                /* @__PURE__ */ a(De, {}),
                /* @__PURE__ */ a("span", { className: "sr-only", children: "Close" })
              ]
            }
          )
        ]
      }
    )
  ] });
}
function Rr({ className: e, ...t }) {
  return /* @__PURE__ */ a(
    "div",
    {
      "data-slot": "sheet-header",
      className: o("flex flex-col gap-1.5 p-8", e),
      ...t
    }
  );
}
function $r({ className: e, ...t }) {
  return /* @__PURE__ */ a(
    "div",
    {
      "data-slot": "sheet-footer",
      className: o("mt-auto flex flex-col gap-2 p-8", e),
      ...t
    }
  );
}
function jr({ className: e, ...t }) {
  return /* @__PURE__ */ a(
    h.Title,
    {
      "data-slot": "sheet-title",
      className: o(
        "font-heading text-lg font-semibold tracking-wider text-foreground uppercase",
        e
      ),
      ...t
    }
  );
}
function Lr({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    h.Description,
    {
      "data-slot": "sheet-description",
      className: o(
        "mt-0.5 text-sm leading-relaxed text-muted-foreground",
        e
      ),
      ...t
    }
  );
}
function Mr({ ...e }) {
  return /* @__PURE__ */ a(de.Root, { "data-slot": "collapsible", ...e });
}
function Vr({ ...e }) {
  return /* @__PURE__ */ a(de.Trigger, { "data-slot": "collapsible-trigger", ...e });
}
function Fr({ ...e }) {
  return /* @__PURE__ */ a(de.Panel, { "data-slot": "collapsible-content", ...e });
}
function Gr({
  align: e = "start",
  className: t,
  children: r,
  ...n
}) {
  return /* @__PURE__ */ d(
    k.Root,
    {
      "data-slot": "navigation-menu",
      className: o(
        "group/navigation-menu relative flex max-w-max flex-1 items-center justify-center",
        t
      ),
      ...n,
      children: [
        r,
        /* @__PURE__ */ a(jt, { align: e })
      ]
    }
  );
}
function qr({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    k.List,
    {
      "data-slot": "navigation-menu-list",
      className: o(
        "group flex flex-1 list-none items-center justify-center gap-0",
        e
      ),
      ...t
    }
  );
}
function Br({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    k.Item,
    {
      "data-slot": "navigation-menu-item",
      className: o("relative", e),
      ...t
    }
  );
}
const $t = U(
  "group/navigation-menu-trigger inline-flex h-9 w-max items-center justify-center rounded-none px-4.5 py-2.5 text-sm font-medium transition-all outline-none hover:bg-muted focus:bg-muted focus-visible:ring-2 focus-visible:ring-ring/30 focus-visible:outline-1 disabled:pointer-events-none disabled:opacity-50 data-popup-open:bg-muted/50 data-popup-open:hover:bg-muted data-open:bg-muted/50 data-open:hover:bg-muted data-open:focus:bg-muted"
);
function Er({
  className: e,
  children: t,
  ...r
}) {
  return /* @__PURE__ */ d(
    k.Trigger,
    {
      "data-slot": "navigation-menu-trigger",
      className: o($t(), "group", e),
      ...r,
      children: [
        t,
        " ",
        /* @__PURE__ */ a(
          W,
          {
            className: "relative top-px ml-1 size-3 transition duration-300 group-data-popup-open/navigation-menu-trigger:rotate-180 group-data-open/navigation-menu-trigger:rotate-180",
            "aria-hidden": "true"
          }
        )
      ]
    }
  );
}
function Or({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    k.Content,
    {
      "data-slot": "navigation-menu-content",
      className: o(
        "data-ending-style:data-activation-direction=left:translate-x-[50%] data-ending-style:data-activation-direction=right:translate-x-[-50%] data-starting-style:data-activation-direction=left:translate-x-[-50%] data-starting-style:data-activation-direction=right:translate-x-[50%] h-full w-auto p-2.5 pr-3 transition-[opacity,transform,translate] duration-[0.35s] ease-[cubic-bezier(0.22,1,0.36,1)] group-data-[viewport=false]/navigation-menu:rounded-none group-data-[viewport=false]/navigation-menu:bg-popover group-data-[viewport=false]/navigation-menu:text-popover-foreground group-data-[viewport=false]/navigation-menu:shadow-md group-data-[viewport=false]/navigation-menu:ring-1 group-data-[viewport=false]/navigation-menu:ring-foreground/10 group-data-[viewport=false]/navigation-menu:duration-300 data-ending-style:opacity-0 data-starting-style:opacity-0 data-[motion=from-end]:slide-in-from-right-52 data-[motion=from-start]:slide-in-from-left-52 data-[motion=to-end]:slide-out-to-right-52 data-[motion=to-start]:slide-out-to-left-52 data-[motion^=from-]:animate-in data-[motion^=from-]:fade-in data-[motion^=to-]:animate-out data-[motion^=to-]:fade-out **:data-[slot=navigation-menu-link]:focus:ring-0 **:data-[slot=navigation-menu-link]:focus:outline-none group-data-[viewport=false]/navigation-menu:data-open:animate-in group-data-[viewport=false]/navigation-menu:data-open:fade-in-0 group-data-[viewport=false]/navigation-menu:data-open:zoom-in-95 group-data-[viewport=false]/navigation-menu:data-closed:animate-out group-data-[viewport=false]/navigation-menu:data-closed:fade-out-0 group-data-[viewport=false]/navigation-menu:data-closed:zoom-out-95",
        e
      ),
      ...t
    }
  );
}
function jt({
  className: e,
  side: t = "bottom",
  sideOffset: r = 8,
  align: n = "start",
  alignOffset: i = 0,
  ...s
}) {
  return /* @__PURE__ */ a(k.Portal, { children: /* @__PURE__ */ a(
    k.Positioner,
    {
      side: t,
      sideOffset: r,
      align: n,
      alignOffset: i,
      className: o(
        "isolate z-50 h-(--positioner-height) w-(--positioner-width) max-w-(--available-width) transition-[top,left,right,bottom] duration-[0.35s] ease-[cubic-bezier(0.22,1,0.36,1)] data-instant:transition-none data-[side=bottom]:before:top-[-10px] data-[side=bottom]:before:right-0 data-[side=bottom]:before:left-0",
        e
      ),
      ...s,
      children: /* @__PURE__ */ a(k.Popup, { className: "data-[ending-style]:easing-[ease] xs:w-(--popup-width) relative h-(--popup-height) w-(--popup-width) origin-(--transform-origin) rounded-none bg-popover text-popover-foreground shadow-md ring-1 ring-foreground/10 transition-[opacity,transform,width,height,scale,translate] duration-[0.35s] ease-[cubic-bezier(0.22,1,0.36,1)] outline-none data-ending-style:scale-90 data-ending-style:opacity-0 data-ending-style:duration-150 data-starting-style:scale-90 data-starting-style:opacity-0", children: /* @__PURE__ */ a(k.Viewport, { className: "relative size-full overflow-hidden" }) })
    }
  ) });
}
function Ur({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    k.Link,
    {
      "data-slot": "navigation-menu-link",
      className: o(
        "flex items-center gap-1.5 rounded-none p-3 text-sm transition-all outline-none hover:bg-muted focus:bg-muted focus-visible:ring-2 focus-visible:ring-ring/30 focus-visible:outline-1 in-data-[slot=navigation-menu-content]:rounded-none data-[active=true]:bg-muted/50 data-[active=true]:hover:bg-muted data-[active=true]:focus:bg-muted [&_svg:not([class*='size-'])]:size-3.5",
        e
      ),
      ...t
    }
  );
}
function Hr({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    k.Icon,
    {
      "data-slot": "navigation-menu-indicator",
      className: o(
        "top-full z-1 flex h-1.5 items-end justify-center overflow-hidden data-[state=hidden]:animate-out data-[state=hidden]:fade-out data-[state=visible]:animate-in data-[state=visible]:fade-in",
        e
      ),
      ...t,
      children: /* @__PURE__ */ a("div", { className: "relative top-[60%] h-2 w-2 rotate-45 rounded-none bg-border shadow-md" })
    }
  );
}
function Jr({ ...e }) {
  return /* @__PURE__ */ a(R.Root, { "data-slot": "popover", ...e });
}
function Xr({ ...e }) {
  return /* @__PURE__ */ a(R.Trigger, { "data-slot": "popover-trigger", ...e });
}
function Wr({
  className: e,
  align: t = "center",
  alignOffset: r = 0,
  side: n = "bottom",
  sideOffset: i = 4,
  ...s
}) {
  return /* @__PURE__ */ a(R.Portal, { children: /* @__PURE__ */ a(
    R.Positioner,
    {
      align: t,
      alignOffset: r,
      side: n,
      sideOffset: i,
      className: "isolate z-50",
      children: /* @__PURE__ */ a(
        R.Popup,
        {
          "data-slot": "popover-content",
          className: o(
            "z-50 flex w-72 origin-(--transform-origin) flex-col gap-4 rounded-none bg-popover p-4 text-sm text-popover-foreground shadow-md ring-1 ring-foreground/10 outline-hidden duration-100 data-[side=bottom]:slide-in-from-top-2 data-[side=inline-end]:slide-in-from-left-2 data-[side=inline-start]:slide-in-from-right-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 data-open:animate-in data-open:fade-in-0 data-open:zoom-in-95 data-closed:animate-out data-closed:fade-out-0 data-closed:zoom-out-95",
            e
          ),
          ...s
        }
      )
    }
  ) });
}
function Yr({ className: e, ...t }) {
  return /* @__PURE__ */ a(
    "div",
    {
      "data-slot": "popover-header",
      className: o("flex flex-col gap-1 text-sm", e),
      ...t
    }
  );
}
function Kr({ className: e, ...t }) {
  return /* @__PURE__ */ a(
    R.Title,
    {
      "data-slot": "popover-title",
      className: o("text-xs font-semibold uppercase", e),
      ...t
    }
  );
}
function Qr({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    R.Description,
    {
      "data-slot": "popover-description",
      className: o(
        "mt-0.5 text-sm leading-relaxed text-muted-foreground",
        e
      ),
      ...t
    }
  );
}
function Zr({ className: e, ...t }) {
  return /* @__PURE__ */ a(
    We,
    {
      "data-slot": "spinner",
      role: "status",
      "aria-label": "Loading",
      className: o("size-4 animate-spin", e),
      ...t
    }
  );
}
function en({
  className: e,
  size: t = "default",
  ...r
}) {
  return /* @__PURE__ */ a(
    le.Root,
    {
      "data-slot": "avatar",
      "data-size": t,
      className: o(
        "group/avatar relative flex size-8 shrink-0 rounded-full select-none after:absolute after:inset-0 after:rounded-full after:border after:border-border after:mix-blend-darken data-[size=lg]:size-10 data-[size=sm]:size-6 dark:after:mix-blend-lighten",
        e
      ),
      ...r
    }
  );
}
function tn({ className: e, ...t }) {
  return /* @__PURE__ */ a(
    le.Image,
    {
      "data-slot": "avatar-image",
      className: o(
        "aspect-square size-full rounded-full object-cover",
        e
      ),
      ...t
    }
  );
}
function an({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    le.Fallback,
    {
      "data-slot": "avatar-fallback",
      className: o(
        "flex size-full items-center justify-center rounded-full bg-muted text-sm text-muted-foreground group-data-[size=sm]/avatar:text-xs",
        e
      ),
      ...t
    }
  );
}
const Lt = U(
  "group/alert relative grid w-full gap-1 border bg-background px-4 py-3 text-left text-sm after:absolute after:-inset-y-px after:-left-px after:w-0.5 has-data-[slot=alert-action]:relative has-data-[slot=alert-action]:pr-18 has-[>svg]:grid-cols-[auto_1fr] has-[>svg]:gap-x-2.5 *:[svg]:row-span-2 *:[svg]:translate-y-0.5 *:[svg]:text-current *:[svg:not([class*='size-'])]:size-4",
  {
    variants: {
      variant: {
        default: "bg-card text-card-foreground after:bg-foreground",
        destructive: "bg-card text-destructive after:bg-destructive *:data-[slot=alert-description]:text-destructive/90 *:[svg]:text-current"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
);
function rn({
  className: e,
  variant: t,
  ...r
}) {
  return /* @__PURE__ */ a(
    "div",
    {
      "data-slot": "alert",
      role: "alert",
      className: o(Lt({ variant: t }), e),
      ...r
    }
  );
}
function nn({ className: e, ...t }) {
  return /* @__PURE__ */ a(
    "div",
    {
      "data-slot": "alert-title",
      className: o(
        "text-sm font-semibold group-has-[>svg]/alert:col-start-2 [&_a]:underline [&_a]:underline-offset-3 [&_a]:hover:text-foreground",
        e
      ),
      ...t
    }
  );
}
function on({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    "div",
    {
      "data-slot": "alert-description",
      className: o(
        "text-sm text-balance text-muted-foreground md:text-pretty [&_a]:underline [&_a]:underline-offset-3 [&_a]:hover:text-foreground [&_p:not(:last-child)]:mb-4",
        e
      ),
      ...t
    }
  );
}
const Mt = 2e5;
function Vt(e) {
  if (e.length === 0 || e.length > Mt)
    return e;
  let t = 0, r = "";
  for (; t < e.length; ) {
    const n = Ft(e, t);
    if (n === -1) {
      r += e.slice(t);
      break;
    }
    const i = Gt(e, n);
    if (i === -1) {
      r += e.slice(t);
      break;
    }
    const s = e.slice(n, i + 1);
    let c;
    try {
      c = JSON.parse(s);
    } catch {
      r += e.slice(t, n + 1), t = n + 1;
      continue;
    }
    if (!qt(c)) {
      r += e.slice(t, i + 1), t = i + 1;
      continue;
    }
    r += e.slice(t, n), r += ne(c, 0), t = i + 1;
  }
  return r;
}
function ne(e, t) {
  if (e === null)
    return "null";
  if (typeof e == "string")
    return `"${e.replace(/"/g, '\\"')}"`;
  if (typeof e == "number" || typeof e == "boolean")
    return String(e);
  if (Array.isArray(e)) {
    if (e.length === 0)
      return "[]";
    const r = "  ".repeat(t + 1), n = "  ".repeat(t);
    return `[
${e.map((s) => r + ne(s, t + 1)).join(`,
`)}
${n}]`;
  }
  if (typeof e == "object") {
    const r = Object.entries(e);
    if (r.length === 0)
      return "{}";
    const n = "  ".repeat(t + 1), i = "  ".repeat(t);
    return `{
${r.map(
      ([c, u]) => `${n}${JSON.stringify(c)}: ${ne(u, t + 1)}`
    ).join(`,
`)}
${i}}`;
  }
  return String(e);
}
function Ft(e, t) {
  for (let r = t; r < e.length; r++) {
    const n = e[r];
    if (n === "{" || n === "[")
      return r;
  }
  return -1;
}
function Gt(e, t) {
  const r = e[t], n = r === "{" ? "}" : "]";
  let i = 0, s = !1, c = !1;
  for (let u = t; u < e.length; u++) {
    const m = e[u];
    if (c) {
      c = !1;
      continue;
    }
    if (s) {
      m === "\\" ? c = !0 : m === '"' && (s = !1);
      continue;
    }
    if (m === '"')
      s = !0;
    else if (m === r)
      i++;
    else if (m === n && (i--, i === 0))
      return u;
  }
  return -1;
}
function qt(e) {
  return e === null || typeof e != "object" ? !1 : Array.isArray(e) ? e.length > 0 : Object.keys(e).length > 0;
}
const Bt = [
  "prompt_tokens",
  "completion_tokens",
  "input_tokens",
  "output_tokens",
  "inputTokens",
  "outputTokens",
  "inputTokens.total",
  "outputTokens.total",
  "cost",
  "cost_usd_total",
  "cost_details.total_cost"
], Et = /* @__PURE__ */ new Set([
  "model",
  "modelId",
  "provider",
  "type",
  "status",
  "message.model",
  "metadata.used_model",
  "metadata.used_provider",
  "providerMetadata.llmgateway.usedModel",
  "providerMetadata.llmgateway.usedProvider",
  "providerMetadata.llmgateway.provider",
  ...Bt.flatMap((e) => [
    "usage",
    "message.usage",
    "providerMetadata.llmgateway.usage",
    "providerMetadata.llmgateway",
    "providerMetadata.gateway"
  ].map((t) => `${t}.${e}`))
]), Le = new Set([...Et].flatMap((e) => {
  const t = e.split(".");
  return t.map((r, n) => t.slice(0, n + 1).join("."));
}));
Le.add("choices");
Le.add("error");
var ye;
(function(e) {
  e.STATIC = "static", e.DYNAMIC = "dynamic";
})(ye || (ye = {}));
var G;
(function(e) {
  e.SMALL = "small", e.DEFAULT = "default", e.LARGE = "large", e.XLARGE = "xlarge";
})(G || (G = {}));
G.SMALL + "", G.DEFAULT + "", G.LARGE + "", G.XLARGE + "";
var we;
(function(e) {
  e.INFO = "info", e.ERROR = "error", e.WARNING = "warning";
})(we || (we = {}));
function ke(e) {
  return e.confidence === "confirmed" && ["transport", "platform_dependency", "platform_runtime"].includes(e.category) ? "Ploy issue" : e.category === "application_response" ? "Application response" : e.category === "application_exception" ? "Application exception" : e.category === "application_input" ? "Application input / limit" : e.category === "downstream_disconnect" ? "Client connection closed" : e.category === "none" ? "No failure observed" : "Cause unknown";
}
const Ne = {
  // Foreground colors
  30: "text-gray-900 dark:text-gray-900",
  31: "text-red-600 dark:text-red-500",
  32: "text-green-600 dark:text-green-500",
  33: "text-yellow-600 dark:text-yellow-500",
  34: "text-blue-600 dark:text-blue-500",
  35: "text-purple-600 dark:text-purple-500",
  36: "text-cyan-600 dark:text-cyan-500",
  37: "text-gray-700 dark:text-gray-300",
  90: "text-gray-500 dark:text-gray-500",
  91: "text-red-500 dark:text-red-400",
  92: "text-green-500 dark:text-green-400",
  93: "text-yellow-500 dark:text-yellow-400",
  94: "text-blue-500 dark:text-blue-400",
  95: "text-purple-500 dark:text-purple-400",
  96: "text-cyan-500 dark:text-cyan-400",
  97: "text-gray-900 dark:text-white",
  // Background colors
  40: "bg-gray-900",
  41: "bg-red-500",
  42: "bg-green-500",
  43: "bg-yellow-500",
  44: "bg-blue-500",
  45: "bg-purple-500",
  46: "bg-cyan-500",
  47: "bg-gray-300",
  100: "bg-gray-500",
  101: "bg-red-400",
  102: "bg-green-400",
  103: "bg-yellow-400",
  104: "bg-blue-400",
  105: "bg-purple-400",
  106: "bg-cyan-400",
  107: "bg-white"
}, ze = {
  1: "font-bold",
  2: "opacity-50",
  3: "italic",
  4: "underline"
};
function Ot(e) {
  const t = [], r = /\x1b\[([0-9;]+)m/g;
  let n = 0, i = [], s;
  for (; (s = r.exec(e)) !== null; ) {
    if (s.index > n) {
      const u = e.substring(n, s.index);
      u && t.push({
        text: u,
        classes: [...i]
      });
    }
    const c = s[1].split(";");
    for (const u of c)
      u === "0" || u === "" ? i = [] : Ne[u] ? i.push(Ne[u]) : ze[u] && i.push(ze[u]);
    n = r.lastIndex;
  }
  return n < e.length && t.push({
    text: e.substring(n),
    classes: [...i]
  }), t;
}
function Ut({ children: e }) {
  const t = te(() => Ot(e), [e]);
  return t.length === 0 ? e : /* @__PURE__ */ a(Ie, { children: t.map((r, n) => r.classes.length === 0 ? /* @__PURE__ */ a("span", { children: r.text }, n) : /* @__PURE__ */ a("span", { className: r.classes.join(" "), children: r.text }, n)) });
}
function Ht(e) {
  if (!e)
    return "";
  if (typeof e == "string")
    return e;
  if (e.http) {
    const { method: r, statusCode: n, path: i } = e.http;
    return `${r ?? "Unavailable"} ${String(n ?? "---")} ${i ?? "Path unavailable"}`;
  }
  const t = [];
  if (e.message !== void 0 && t.push(e.message), e.payload !== void 0 && e.payload !== null) {
    const r = typeof e.payload == "string" ? e.payload : JSON.stringify(e.payload);
    t.push(r);
  }
  return t.length > 0 ? t.join(" ") : "";
}
function Jt(e) {
  switch (e) {
    case "error":
      return "text-red-500 dark:text-red-400";
    case "warning":
    case "warn":
      return "text-yellow-600 dark:text-yellow-400";
    case "debug":
      return "text-cyan-600 dark:text-cyan-400";
    case "trace":
      return "text-purple-500 dark:text-purple-400";
    case "info":
    case "log":
    default:
      return "text-gray-600 dark:text-gray-300";
  }
}
function Xt(e) {
  switch (e) {
    case "error":
      return /* @__PURE__ */ a(tt, { className: "size-3.5 text-red-500 dark:text-red-400" });
    case "warning":
    case "warn":
      return /* @__PURE__ */ a(et, { className: "size-3.5 text-orange-500 dark:text-orange-400" });
    case "debug":
      return /* @__PURE__ */ a(Ze, { className: "size-3.5 text-cyan-600 dark:text-cyan-400" });
    case "trace":
      return /* @__PURE__ */ a(Qe, { className: "size-3.5 text-purple-500 dark:text-purple-400" });
    case "info":
    case "log":
    default:
      return /* @__PURE__ */ a(Ke, { className: "size-3.5 text-gray-400 dark:text-gray-500" });
  }
}
function Wt(e) {
  return e ? e >= 500 || e >= 400 ? "text-red-500 dark:text-red-400" : e >= 300 ? "text-yellow-600 dark:text-yellow-400" : "text-green-600 dark:text-green-400" : "text-gray-400";
}
function E(e) {
  if (!(!e || typeof e == "string"))
    return e.http;
}
function Se(e) {
  return e > 0 && e < 1 ? "<1ms" : Be(Math.round(e));
}
const sn = {
  key: "http-status",
  width: "w-10",
  getValue: (e) => {
    var t;
    return (t = E(e.message)) == null ? void 0 : t.statusCode;
  },
  getColor: (e) => Wt(e),
  format: (e) => e != null ? String(e) : "---"
}, dn = {
  key: "http-method",
  width: "w-12",
  color: "text-blue-600 dark:text-blue-400",
  getValue: (e) => {
    var t;
    return (t = E(e.message)) == null ? void 0 : t.method;
  }
}, ln = {
  key: "build-command",
  width: "w-40",
  color: "text-blue-600 dark:text-blue-400",
  getValue: (e) => e.command,
  format: (e) => e ? `[${String(e)}]` : ""
};
function Yt(e) {
  if (e == null)
    return "";
  const t = String(e);
  try {
    const r = new URL(t);
    return `${r.pathname}${r.search}` || t;
  } catch {
    return t;
  }
}
const cn = {
  key: "request-url",
  width: "w-64",
  color: "text-blue-600 dark:text-blue-400",
  getValue: (e) => e.requestUrl,
  format: Yt
};
function un(e) {
  return {
    key: "trace-id",
    width: "w-20",
    color: "text-purple-600 dark:text-purple-400",
    getValue: (t) => t.traceId ? t.traceId.substring(0, 8) : void 0,
    onClick: (t) => {
      t.traceId && e(t.traceId);
    },
    copyValue: (t) => t.traceId
  };
}
const Ce = {
  cron: {
    label: "cron trigger",
    description: "Invoked by a scheduled cron trigger"
  },
  queue: {
    label: "queue message",
    description: "Invoked to deliver a queue message"
  },
  timer: {
    label: "timer",
    description: "Invoked by a timer firing"
  },
  workflow: {
    label: "workflow",
    description: "Invoked to run a workflow step"
  },
  email: {
    label: "email",
    description: "Invoked to deliver a received email"
  }
};
function Te({
  title: e,
  children: t
}) {
  return /* @__PURE__ */ a(
    "span",
    {
      title: e,
      className: "mt-1 inline-flex items-center rounded px-1.5 py-0.5 font-sans text-xs bg-indigo-50 text-indigo-700 dark:bg-indigo-500/10 dark:text-indigo-300",
      children: t
    }
  );
}
function _e({ value: e }) {
  const [t, r] = oe(!1), n = Ae(null);
  ie(() => () => {
    n.current && clearTimeout(n.current);
  }, []);
  const i = J(
    async (s) => {
      s.stopPropagation();
      try {
        await navigator.clipboard.writeText(e), r(!0), n.current && clearTimeout(n.current), n.current = setTimeout(() => {
          r(!1);
        }, 1500);
      } catch {
      }
    },
    [e]
  );
  return /* @__PURE__ */ a(
    "button",
    {
      type: "button",
      onClick: i,
      "aria-label": t ? "Copied" : "Copy",
      title: t ? "Copied" : "Copy",
      className: o(
        "shrink-0 p-0.5 rounded text-gray-400 dark:text-gray-500",
        "hover:text-gray-700 dark:hover:text-gray-200",
        "hover:bg-gray-100 dark:hover:bg-white/[0.08]",
        "transition-colors cursor-pointer"
      ),
      children: t ? /* @__PURE__ */ a(ae, { className: "size-3 text-green-600 dark:text-green-400" }) : /* @__PURE__ */ a(Ye, { className: "size-3" })
    }
  );
}
const Kt = o(
  "relative overflow-hidden",
  "dark:bg-[#1a1a1a] bg-white",
  "border dark:border-white/[0.08] border-gray-200",
  "backdrop-blur-xl",
  "rounded-2xl",
  "dark:shadow-[0_8px_32px_rgba(0,0,0,0.4)] shadow-[0_2px_8px_rgba(0,0,0,0.04)]"
);
function pn({
  logs: e,
  isLoading: t = !1,
  autoScroll: r = !0,
  emptyMessage: n = "No logs available",
  className: i = "h-[400px]",
  parseAnsi: s = !1,
  summaryFields: c = [],
  showTimings: u = !1,
  title: m,
  showHeader: b = !0,
  attributionFilter: w,
  onAttributionFilterChange: N
}) {
  const v = Ae(null);
  ie(() => {
    r && v.current && e.length > 0 && (v.current.scrollTop = v.current.scrollHeight);
  }, [e, r]);
  const $ = J((f) => {
    const g = f.timestamp ?? f.createdAt;
    return pe(g);
  }, []), _ = J(
    (f, g) => {
      var F;
      const l = g.getValue(f);
      if (l == null)
        return null;
      const A = g.format ? g.format(l) : String(l);
      if (!A)
        return null;
      const L = g.getColor ? g.getColor(l) : g.color ?? "text-gray-600 dark:text-gray-300", M = (F = g.copyValue) == null ? void 0 : F.call(g, f), V = g.onClick ? /* @__PURE__ */ a(
        "button",
        {
          type: "button",
          title: A,
          className: o(
            "shrink-0 truncate text-left",
            g.width,
            L,
            "hover:underline cursor-pointer"
          ),
          onClick: () => {
            g.onClick(f);
          },
          children: A
        }
      ) : /* @__PURE__ */ a(
        "span",
        {
          title: A,
          className: o("shrink-0 truncate", g.width, L),
          children: A
        }
      );
      return M ? /* @__PURE__ */ d(
        "span",
        {
          className: "flex items-center gap-1 shrink-0 min-w-0",
          children: [
            V,
            /* @__PURE__ */ a(_e, { value: M })
          ]
        },
        g.key
      ) : /* @__PURE__ */ a("span", { className: "flex shrink-0 min-w-0", children: V }, g.key);
    },
    []
  ), z = J(
    (f) => {
      var ce, ue;
      const g = Vt(Ht(f.message)), l = E(f.message), A = !!l, L = (l == null ? void 0 : l.wallTime) ?? null, M = (l == null ? void 0 : l.cpuTime) ?? null, V = (L ?? 0) > 0 || (M ?? 0) > 0, F = (l == null ? void 0 : l.requestSize) ?? null, Q = (l == null ? void 0 : l.responseSize) ?? null, Z = F !== null || Q !== null, Me = (F ?? 0) + (Q ?? 0);
      return /* @__PURE__ */ d(
        "div",
        {
          className: o(
            "flex flex-col sm:flex-row sm:items-start gap-2 sm:gap-4",
            "py-1.5 px-3 rounded-lg",
            "font-mono text-xs sm:text-sm leading-relaxed",
            "transition-colors duration-150",
            "hover:bg-gray-50 dark:hover:bg-white/[0.04]",
            "border-b border-transparent hover:border-gray-100 dark:hover:border-white/[0.04]"
          ),
          children: [
            /* @__PURE__ */ a("span", { className: "text-gray-500 dark:text-gray-500 shrink-0 w-24 select-none", children: $(f) }),
            /* @__PURE__ */ a("span", { className: "shrink-0 flex items-center justify-center w-4", children: Xt(f.level) }),
            c.map((C) => _(f, C)),
            /* @__PURE__ */ d("div", { className: "min-w-0 flex-1", children: [
              /* @__PURE__ */ a(
                "span",
                {
                  className: o(
                    "block break-all whitespace-pre-wrap",
                    A ? "text-gray-700 dark:text-gray-300" : Jt(f.level)
                  ),
                  children: s ? /* @__PURE__ */ a(Ut, { children: g }) : g
                }
              ),
              l != null && l.caller ? /* @__PURE__ */ d(
                Te,
                {
                  title: `Invoked through a service binding by deployment ${l.caller.deploymentId}, without leaving the platform network`,
                  children: [
                    "Internal · from",
                    " ",
                    l.caller.projectName ?? l.caller.deploymentId
                  ]
                }
              ) : (l == null ? void 0 : l.trigger) && /* @__PURE__ */ d(Te, { title: Ce[l.trigger].description, children: [
                "Internal · ",
                Ce[l.trigger].label
              ] }),
              (l == null ? void 0 : l.attribution) && /* @__PURE__ */ d("details", { className: "mt-1 min-w-0 text-gray-700 dark:text-gray-300", children: [
                /* @__PURE__ */ d("summary", { className: "cursor-pointer", children: [
                  ke(l.attribution),
                  l.attribution.confidence === "suspected" ? " · suspected" : ""
                ] }),
                /* @__PURE__ */ d("div", { className: "mt-2 border-l border-gray-200 pl-3 space-y-1 text-xs break-words dark:border-gray-700", children: [
                  /* @__PURE__ */ d("p", { children: [
                    "Response: ",
                    l.attribution.responseSource,
                    ". Confidence:",
                    " ",
                    l.attribution.confidence,
                    "."
                  ] }),
                  /* @__PURE__ */ d("p", { children: [
                    l.attribution.service ? `${l.attribution.service}: ` : "",
                    l.attribution.code.replaceAll("_", " ")
                  ] }),
                  l.attribution.confidence !== "confirmed" && /* @__PURE__ */ a("p", { children: "The response source does not establish the underlying cause." }),
                  l.attribution.missingEvidence && /* @__PURE__ */ d("p", { children: [
                    "Unavailable evidence:",
                    " ",
                    ((ce = l.attribution.missingEvidenceReasons) == null ? void 0 : ce.map((C) => C.replaceAll("_", " ")).join(", ")) || "request details",
                    "."
                  ] }),
                  l.requestId && /* @__PURE__ */ d("div", { className: "flex gap-2 items-center", children: [
                    /* @__PURE__ */ a("span", { className: "min-w-0 break-all", children: l.requestId }),
                    /* @__PURE__ */ a(_e, { value: l.requestId })
                  ] }),
                  (ue = l.diagnosticTimeline) == null ? void 0 : ue.map((C) => /* @__PURE__ */ d("p", { children: [
                    pe(C.timestamp),
                    " · ",
                    C.service,
                    " ·",
                    " ",
                    C.code.replaceAll("_", " ")
                  ] }, C.eventId))
                ] })
              ] })
            ] }),
            u && (V || Z) && /* @__PURE__ */ d("span", { className: "flex shrink-0 gap-3 ml-auto tabular-nums", children: [
              /* @__PURE__ */ a(
                "span",
                {
                  title: "Wall time: how long the request took, including waiting on I/O",
                  className: "w-16 text-right text-purple-600 dark:text-purple-400",
                  children: V && L !== null && Se(L)
                }
              ),
              /* @__PURE__ */ a(
                "span",
                {
                  title: "CPU time: time spent running your code",
                  className: "w-20 text-right text-gray-500 dark:text-gray-400",
                  children: V && M !== null && `CPU ${Se(M)}`
                }
              ),
              /* @__PURE__ */ a(
                "span",
                {
                  title: Z ? `Bandwidth: ${ee(F ?? 0)} received in the request body, ${ee(Q ?? 0)} sent in the response body` : void 0,
                  className: "w-20 text-right text-sky-600 dark:text-sky-400",
                  children: Z && ee(Me)
                }
              )
            ] })
          ]
        },
        f.id
      );
    },
    [
      $,
      c,
      _,
      s,
      u
    ]
  ), [I, K] = oe("all"), p = w ?? I, j = N ?? K, S = te(
    () => p === "all" ? e : e.filter((f) => {
      const g = E(f.message);
      return g ? g.attribution ? ke(g.attribution) === p : p === "Cause unknown" : !1;
    }),
    [e, p]
  ), H = te(() => t && e.length === 0 ? /* @__PURE__ */ a("div", { className: "flex items-center justify-center h-full p-6", children: /* @__PURE__ */ a("div", { className: "text-sm text-gray-500 dark:text-gray-400", children: "Loading logs..." }) }) : e.length === 0 ? /* @__PURE__ */ a("div", { className: "flex items-center justify-center h-full p-6", children: /* @__PURE__ */ a("div", { className: "text-sm text-gray-500 dark:text-gray-400", children: n }) }) : /* @__PURE__ */ a("div", { className: "space-y-0.5 p-3", children: S.map(z) }), [t, e, S, n, z]);
  return /* @__PURE__ */ d("div", { className: o(Kt, "flex flex-col", i), children: [
    /* @__PURE__ */ a(
      "div",
      {
        className: "absolute inset-0 pointer-events-none dark:block hidden",
        style: {
          background: "radial-gradient(circle at top left, rgba(255, 255, 255, 0.08) 0%, transparent 50%)"
        }
      }
    ),
    /* @__PURE__ */ a(
      "div",
      {
        className: "absolute inset-0 pointer-events-none block dark:hidden",
        style: {
          background: "radial-gradient(circle at top left, rgba(0, 0, 0, 0.06) 0%, transparent 50%)"
        }
      }
    ),
    (p !== "all" || e.some((f) => {
      var g;
      return (g = E(f.message)) == null ? void 0 : g.attribution;
    })) && /* @__PURE__ */ d("label", { className: "relative z-10 px-3 pt-2 text-sm", children: [
      "Filter loaded requests:",
      " ",
      /* @__PURE__ */ a(
        "select",
        {
          "aria-label": "Request attribution",
          value: p,
          onChange: (f) => j(f.target.value),
          className: "bg-transparent border rounded px-2 py-1",
          children: [
            "all",
            "Ploy issue",
            "Application response",
            "Application exception",
            "Application input / limit",
            "Cause unknown",
            "Client connection closed"
          ].map((f) => /* @__PURE__ */ a("option", { value: f, children: f === "all" ? "All causes" : f }, f))
        }
      )
    ] }),
    b && /* @__PURE__ */ a("div", { className: "relative z-10 px-6 py-4 border-b dark:border-white/[0.08] border-gray-200 dark:bg-white/[0.02] bg-gray-50/50", children: /* @__PURE__ */ d("h2", { className: "font-semibold text-sm tracking-wide text-gray-900 dark:text-white", children: [
      m ?? "Logs",
      /* @__PURE__ */ d("span", { className: "text-gray-500 dark:text-gray-500 ml-2 font-normal", children: [
        "(",
        S.length,
        S.length !== e.length ? ` of ${e.length}` : "",
        ")"
      ] })
    ] }) }),
    /* @__PURE__ */ a(
      "div",
      {
        ref: v,
        className: o(
          "relative z-10 flex-1 overflow-y-auto overflow-x-auto",
          "scrollbar-thin scrollbar-thumb-gray-300 dark:scrollbar-thumb-white/10 scrollbar-track-transparent"
        ),
        children: H
      }
    )
  ] });
}
export {
  Sr as Accordion,
  _r as AccordionContent,
  Cr as AccordionItem,
  Tr as AccordionTrigger,
  rn as Alert,
  on as AlertDescription,
  Ja as AlertDialog,
  er as AlertDialogAction,
  tr as AlertDialogCancel,
  Wa as AlertDialogContent,
  Za as AlertDialogDescription,
  Ka as AlertDialogFooter,
  Ya as AlertDialogHeader,
  St as AlertDialogOverlay,
  zt as AlertDialogPortal,
  Qa as AlertDialogTitle,
  Xa as AlertDialogTrigger,
  nn as AlertTitle,
  en as Avatar,
  an as AvatarFallback,
  tn as AvatarImage,
  za as Badge,
  q as Button,
  qe as Card,
  mn as CardAction,
  bn as CardContent,
  hn as CardDescription,
  vn as CardFooter,
  xn as CardHeader,
  yn as CardTitle,
  gr as Checkbox,
  Mr as Collapsible,
  Fr as CollapsibleContent,
  Vr as CollapsibleTrigger,
  Fa as Dialog,
  qa as DialogClose,
  Ba as DialogContent,
  Ha as DialogDescription,
  Oa as DialogFooter,
  Ea as DialogHeader,
  Nt as DialogOverlay,
  kt as DialogPortal,
  Ua as DialogTitle,
  Ga as DialogTrigger,
  Va as Dropdown,
  ht as DropdownMenu,
  $a as DropdownMenuCheckboxItem,
  $e as DropdownMenuContent,
  Aa as DropdownMenuGroup,
  xe as DropdownMenuItem,
  xt as DropdownMenuLabel,
  Ia as DropdownMenuPortal,
  ja as DropdownMenuRadioGroup,
  La as DropdownMenuRadioItem,
  yt as DropdownMenuSeparator,
  Ma as DropdownMenuShortcut,
  Da as DropdownMenuSub,
  Ra as DropdownMenuSubContent,
  Pa as DropdownMenuSubTrigger,
  vt as DropdownMenuTrigger,
  Sa as Duration,
  Ge as GlassContainer,
  mt as IconContainer,
  Ca as Input,
  Nr as Label,
  pn as LogsViewer,
  Ta as ModelCard,
  Gr as NavigationMenu,
  Or as NavigationMenuContent,
  Hr as NavigationMenuIndicator,
  Br as NavigationMenuItem,
  Ur as NavigationMenuLink,
  qr as NavigationMenuList,
  jt as NavigationMenuPositioner,
  Er as NavigationMenuTrigger,
  Jr as Popover,
  Wr as PopoverContent,
  Qr as PopoverDescription,
  Yr as PopoverHeader,
  Kr as PopoverTitle,
  Xr as PopoverTrigger,
  wr as Progress,
  fr as RadioGroup,
  mr as RadioGroupItem,
  _a as ScrollArea,
  bt as ScrollBar,
  ar as Select,
  ir as SelectContent,
  rr as SelectGroup,
  Ct as SelectItem,
  sr as SelectLabel,
  _t as SelectScrollDownButton,
  Tt as SelectScrollUpButton,
  dr as SelectSeparator,
  or as SelectTrigger,
  nr as SelectValue,
  kr as Separator,
  Ir as Sheet,
  Dr as SheetClose,
  Pr as SheetContent,
  Lr as SheetDescription,
  $r as SheetFooter,
  Rr as SheetHeader,
  jr as SheetTitle,
  Ar as SheetTrigger,
  Sn as Skeleton,
  Zr as Spinner,
  kn as SqlResultsTable,
  br as Switch,
  ut as TabButton,
  Cn as Table,
  Tn as TableBody,
  _n as TableCell,
  In as TableFooter,
  An as TableHead,
  Dn as TableHeader,
  Pn as TableRow,
  hr as Tabs,
  yr as TabsContent,
  vr as TabsList,
  xr as TabsTrigger,
  dt as Tag,
  zr as Textarea,
  Nn as Time,
  cr as Tooltip,
  pr as TooltipContent,
  lr as TooltipProvider,
  ur as TooltipTrigger,
  Lt as alertVariants,
  it as badgeVariants,
  ln as buildCommandField,
  ct as buttonVariants,
  o as cn,
  ee as formatBytes,
  Be as formatDuration,
  lt as formatDurationShort,
  pe as formatLogTime,
  dn as httpMethodField,
  sn as httpStatusField,
  un as makeTraceIdField,
  $t as navigationMenuTriggerStyle,
  Vt as prettyPrintEmbeddedJson,
  cn as requestUrlField
};
